/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";
import { NumPad } from "@lemmonhq/uikit";

interface AddCustomerModalProps {
  onClose: () => void;
  onConfirm: (count: number) => void;
}

export const AddCustomerModal = defineComponent<AddCustomerModalProps>({
  name: "AddCustomerModal",
  props: ["onClose", "onConfirm"],
  setup(props) {
    const seatCount = ref("");
    const { t } = useLocalization();

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      const count = parseInt(seatCount.value);
      if (Number.isFinite(count)) {
        props.onConfirm(count);
      }
    };

    return () => (
      <LemmonModal
        onClose={props.onClose}
        title={t("pos.tables.add_seats")}
        renderButtons={() => (
          <div class="border-t  bg-base-100 p-4">
            <div class="flex flex-col justify-between gap-2 sm:flex-row">
              <button
                onClick={props.onClose}
                class="btn btn-neutral min-h-12 flex-1"
                type="button"
              >
                {t("general.words.cancel")}
              </button>
              <button
                class="btn btn-primary min-h-12 flex-1"
                onClick={handleSubmit}
                disabled={!seatCount.value}
              >
                {t("pos.tables.add_seats")}
              </button>
            </div>
          </div>
        )}
      >
        <div class="mx-auto w-full max-w-md space-y-4 p-4">
          <div class="rounded-2xl border  bg-base-200/40 p-4 text-center">
            <div class="text-sm uppercase tracking-wide ">
              {t("pos.tables.add_seats")}
            </div>
            <div class="mt-2 text-4xl font-semibold text-accent">
              {seatCount.value || "0"}
            </div>
          </div>
          <NumPad
            value={seatCount.value}
            onChange={(nv) => {
              seatCount.value = nv;
            }}
            secureDisplay={false}
          />
        </div>
      </LemmonModal>
    );
  },
});
